<template lang="pug">
  div(class="eds-iit-checkbox-sign-options")
    v-btn(
      v-for="(option, idx) in options"
      :key="idx"
      :id="setBtnIds(option.key)"
      class="eds-iit-checkbox-sign-options__option"
      @click="option.onClick(option.key)"
      :data-test="`eds-iit-sign-option-${setBtnIds(option.key)}`"
    )
      div(class="eds-iit-checkbox-sign-options__option-content")
        div(class="eds-iit-checkbox-sign-options__option-icon pr-4")
          e-svg-icon(
            v-if="option.icon.svg"
            size="xxlg"
          ) {{ option.icon.name }}
          v-img(
            v-else
            :src="option.icon.url"
            :max-width="40"
          )
        div(class="text-left")
          h4(class="text-16px medium dark mb-1") {{ option.title }}
          div(
            v-if="!xsDevice"
            class="text-14px fw-300"
          ) {{ option.description }}
      div(class="eds-iit-checkbox-sign-options__option-action")
        e-svg-icon(size="sm") arrow-next
</template>

<script>
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import responsive from '~/mixins/pages/responsive'
import edsIitCheckboxSteps from '~/modules/eds-iit-checkbox/mixins/edsIitCheckboxSteps'
import EDividerLineText from '~/components/elements/dividers/e-divider-line-text'

export default {
  name: 'EdsIitCheckboxSignOptions',
  components: {
    ESvgIcon,
    EDividerLineText
  },
  mixins: [responsive, edsIitCheckboxSteps],
  props: {
    haveSavedKeys: {
      type: Boolean,
      default: false
    },
    visibleOptions: {
      type: Array,
      default: null
    }
  },
  computed: {
    optionsKeyMap() {
      return {
        [this.steps.diiaSign]: ['diia'],
        [this.steps.fileSign]: ['iit', 'fileKey'],
        [this.steps.savedKeys]: ['iit', 'fileKey'],
        [this.steps.smartIdRead]: ['smart_id', 'smartId'],
        [this.steps.monoSign]: ['mono']
      }
    },
    options() {
      const options = [
        {
          key: this.steps.diiaSign,
          title: 'Дія.Підпис',
          description: this.$t('diiaDescription'),
          icon: {
            name: 'diia',
            svg: true
          },
          eventName: 'click_diia',
          onClick: key => this.handleClick(key)
        },
        {
          key: this.haveSavedKeys ? this.steps.savedKeys : this.steps.fileSign,
          title: 'Ключем ЕЦП (КЕП)',
          description: this.$t('iitDescription'),
          icon: {
            url: require('~/assets/images/lock-key-gray-box.png'),
            svg: false
          },
          eventName: 'click_ecp',
          onClick: key => this.handleClick(key)
        },
        {
          key: this.steps.smartIdRead,
          title: 'SmartID',
          description: this.$t('smartIdDescription'),
          icon: {
            name: 'smart-id',
            svg: true
          },
          eventName: 'click_smartid',
          onClick: key => this.handleClick(key)
        },
        {
          key: this.steps.monoSign,
          title: 'monoKEП',
          description: this.$t('monoDescription'),
          icon: {
            name: 'monobank',
            svg: true
          },
          eventName: 'click_mono',
          onClick: key => this.handleClick(key)
        }
      ]
      if (
        !this.visibleOptions ||
        (Array.isArray(this.visibleOptions) && !this.visibleOptions.length)
      ) {
        return options
      }
      return this._.filter(options, option => {
        const keys = this.optionsKeyMap[option.key]
        return keys.some(key => this.visibleOptions.includes(key))
      })
    }
  },
  methods: {
    handleClick(key) {
      this.$emit('select', key)
      window.dataLayer &&
        window.dataLayer.push({
          event: this._.get(
            this._.find(this.options, o => o.key === key),
            'eventName'
          ),
          email: this._.get(this.$User, 'email')
        })
    },
    setBtnIds(key) {
      if (key === this.steps.diiaSign) {
        return 'diia'
      } else if (key === this.steps.fileSign) {
        return 'ecp'
      } else if (key === this.steps.smartIdRead) {
        return 'smartid'
      } else if (key === this.steps.monoSign) {
        return 'mono'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.eds-iit-checkbox-sign-options {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__option {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    height: auto !important;

    border-radius: 16px;

    padding: 24px !important;

    background: $background-gray !important;

    &-content {
      display: flex;
      align-items: center;
    }
  }
}
</style>
